import { Palette } from '@mui/material'

export const sentenceStyle = {
	fontSize: '14px',
}
